import { DataGridEditable } from "components/DataGridEditable/DataGridEditable";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { Toolbar } from "components/Toolbar/Toolbar";
import { useEffect, useRef, useState } from "react";
import { downloadCSV, getPageSize, trans } from "utils/helpers";
import {
  getEditablecolumns,
  getPeriodInitDetail,
  postEditableColumn,
  removePeriodInitDetail,
} from "./api";
import { PeriodInitDetailBulkAdd } from "./PeriodInitDetailBulkAdd";
// import { PeriodInitGroupEditForm } from "./PeriodInitGroupEditForm";
import { MessageType } from "types/enum";
import { ImportForm } from "./ImportForm";
import { TransmissionForm } from "./components/TransmissionForm";
interface props {
  PeriodInitObj: any;
}

export const PeriodInit = ({ PeriodInitObj }: props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const EditType = { False: 0, All: 1, SingleRow: 2, Columns: 3 };
  const [forceUpdate, setForceUpdate] = useState(false);
  const [response, setResponse] = useState<Response | any>(null);
  const [messageType, setMessageType] = useState<any>("info");
  const [pageNum, setPageNum] = useState<any>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [pages, setPages] = useState<any>(0);
  const [search, setSearch] = useState(null);
  const [selectedObj, setSelectedObj] = useState<object | any>(null);
  const [showForm, setShowForm] = useState(false);
  const [mode, setMode] = useState<string | any>();
  const [editAllGrid, setEditAllGrid] = useState<any>(false);
  const [showGroupEdit, setShowGroupEdit] = useState(false);
  const [detailMode, setDetailMode] = useState<any>("create");
  const [editablecolumns, setEditablecolumns] = useState(false);
  const [showPeriodInitBulkAdd, setShowPeriodInitBulkAdd] = useState(false);
  const [changedDataObj, setChangedDataObj] = useState<any>(null);
  const [selectList, setSelectList] = useState<any>([]);
  const [orderBy, setOrderBy] = useState<any>([]);
  const [tbodyData, setTbodyData] = useState<any>([]);
  const [filterlist, setFilterlist] = useState<any>(""); 
  const [catchMessage, setCatchMessage] = useState<any>({type:"info",msg:"NoDataForPreview"});
  const [showImportForm, setShowImportForm] = useState(false)
  const [showtransmissionForm, setShowtransmissionForm] = useState(false)
  const [resetMultiSelect, setResetMultiSelect] = useState<any>(false);
  let calculatedIsAbsoluteUnitConversionRatioFlag = useRef<any>(false);

  const getEditablecolumnsAsync = async () => {
    try {
      const res = await getEditablecolumns();
      setEditablecolumns(res.Data);
    } catch (error) {}
  };
  const changeingData = (data) => {
    if (data && Object.keys(data).length > 0) {
      setChangedDataObj(data);

    } else {
      setChangedDataObj(null);
    }
  };
  const saveChangeingData = async () => {
    if (Object.keys(changedDataObj).length > 0) {
      let PostlistData: any = [];
      let PutlistData: any = [];

      Object.keys(changedDataObj).map((item) => {
        if (changedDataObj[item].Id == null) {
          let data = {
            ...changedDataObj[item],
            ItemValueIn: +changedDataObj[item]?.ItemValueIn.toString()?.replaceAll(
              ",",
              ""
            ),
            QtyIn2: changedDataObj[item].QtyIn2 
              ? changedDataObj[item].QtyIn2
              : null,
          };
          delete data.Operation;
          delete data.SelectAll;
          PostlistData.push(data);
        } else {
          let data = {
            ...changedDataObj[item],
            ItemValueIn: +changedDataObj[item]?.ItemValueIn.toString()?.replaceAll(
              ",",
              ""
            ),
            QtyIn2: changedDataObj[item].QtyIn2
              ? changedDataObj[item].QtyIn2
              : null,
          };
          delete data.Operation;
          delete data.SelectAll;
          PutlistData.push(data);
        }
      });
      try {
        if (PostlistData.length > 0) {
          await postEditableColumn(PostlistData, "post");
        }
      } catch (error) {}
      if (PutlistData.length > 0) {
        await postEditableColumn(PutlistData, "put");
      }
      setForceUpdate(!forceUpdate);
      setChangedDataObj(null);

      setEditAllGrid(EditType.False);

      try {
      } catch (error) {}
    }
  };

  const selectedIdCallback = (obj) => {

      setSelectedObj(obj);
    
  };

  const handleNextPage = () => {
    if (pageNum < pages) {
      setPageNum(pageNum + 1);
      getPeriodInitDetailAsync(pageNum + 1);
    }
  };

  const handlePrevPage = () => {
    if (pageNum > 1) {
      setPageNum((pageNum) => {
        return +pageNum - 1;
      });
      getPeriodInitDetailAsync(pageNum - 1);
    }
  };
  const handleChangePageSize = (e: any) => {
    setPageNum(1);
    setPageSize(+e.currentTarget.value);
    getPageSize("PeriodInit", e.currentTarget.value);
    getPeriodInitDetailAsync(1);
  };

  const handleGoPage = (value) => {
    if (value) {
      if (value < 1 || value > pages) {
      } else {
        setPageNum(+value);
        getPeriodInitDetailAsync(+value);
      }
    } else {
    }
  };

  const searchHandler = (str) => {
    setPageNum(1);
    if (str == "") {
      setSearch(null);
    } else {
      setSearch(str);
    }
  };

  const handleCreate = () => {
    setMode("create");
    setShowPeriodInitBulkAdd(true);
  };

  async function getPeriodInitDetailAsync(PageNum = pageNum) {
    setLoading(false);
    setResponse(null);
    setTbodyData([]);
    let pageSizeChangedByUser = getPageSize("PeriodInit");
    setPageSize(pageSizeChangedByUser);
    try {
      await getEditablecolumnsAsync();
      const res = await getPeriodInitDetail(
         JSON.parse(localStorage.getItem("DefaultInventory") as any).Id ,
        PageNum,
        pageSizeChangedByUser,
        orderBy.length == 0 ? null : orderBy.join(","),
        search,
        filterlist,
        JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)?.Id??undefined
       
      );
      setPages(
        res.Data.TotalRecords > pageSizeChangedByUser
          ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser)
          : 1
      );
      setResponse(res.Data);
      setTbodyData(res.Data.Data);
      setMessageType("info");
    } catch (error) {
      setMessageType("error");
       if(!localStorage.getItem("DefaultInventory") || (JSON.parse(localStorage.getItem("DefaultInventory") as any)?.WarehouseDetailsCount>0 && !JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)?.Id)){
              setCatchMessage({type:"error",msg:"msg_choosewarehouse"})
            }
    }
    setLoading(true);
  }
  const handleRemove = async (id = "") => {
    if (id) {
      setLoading(false);
      try {
        const res = await removePeriodInitDetail([id]);
        setForceUpdate(!forceUpdate);
      } catch (error) {}
      setLoading(true);
    } else {
      let removeListId = selectList.map((item) => {
        return item.Id;
      });
      setLoading(false);
      try {
        const res = await removePeriodInitDetail(removeListId);
        setForceUpdate(!forceUpdate);
      } catch (error) {}
      setLoading(true);
    }
  };
  const clickToolbarCallback = (clickedButtonName: string) => {
    switch (clickedButtonName.toLowerCase()) {
      case "print":
        alert("print");
        break;
      case "excel":
        downloadCSV(response?.Data, 1, trans("PeriodInitDetail"));
        break;
      case "refresh":
        setForceUpdate(!forceUpdate);
        setEditAllGrid(EditType.False);
        break;
      case "edit":
        if (selectedObj) {
          setEditAllGrid(EditType.SingleRow);
        }
        break;
      case "create":
        {
          setDetailMode("create");
          handleCreate();
        }
        break;
      case "editgrid":
        setEditAllGrid(EditType.All);
        break;
      case "groupedit":
        {
          setShowGroupEdit(true);
          setShowPeriodInitBulkAdd(true);
          setDetailMode("edit");
        }

        break;
      case "help":
        alert("call api help");
        break;
      case "save":
        saveChangeingData();
        break;
      case "remove":
        if (!!selectList.length) {
          // Toast(trans("msg_deleteconfirm"), "warning", "alert", handleRemove);
          Toast(
            trans("msg_deleteconfirm"),
            MessageType.confirmDelete,
            handleRemove
          );
        } else {
          // Toast(trans("msg_deleteconfirm"), "warning", "alert", () =>
          //   handleRemove(selectedObj?.Id)
          // );
          if (selectedObj?.Id) {
            Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete, () =>
              handleRemove(selectedObj?.Id)
            );
          } else {
            Toast(trans("msg_selectrow"), MessageType.warning);
          }
        }
        break;
      case "cancel":
        setForceUpdate(!forceUpdate);
        setChangedDataObj(null);
        setEditAllGrid(EditType?.False);
        break;
      case "import": setShowImportForm(true); break;
      case "transfer": setShowtransmissionForm(true); break;
    }
  };
  const selectListCallBack = (list) => {
    setSelectList(list[1]);
  };

  const handleCalculate = (obj, cell, value) => {
    if (obj?.UnitIn2Id!=null) {
      //   محاسبه در صورت داشتن واحد دوم
      if (
        obj?.IsAbsoluteUnitConversionRatio ||
        (!calculatedIsAbsoluteUnitConversionRatioFlag.current &&
          !obj?.IsAbsoluteUnitConversionRatio)||true
      ) {
        //محاسبه واحد ها در صورتی که نسبت مطلق باشد یا نسبت مطلق نباشد و برای بار اول نسبت واحد ها را حساب میکنیم
        if (cell == "QtyIn1") {
          //تعیین واحد دوم بر اساس واحد اول
          return {
            QtyIn2: +value * obj.ConversionRatio,
          };
        }
        if (cell == "QtyIn2") {
          //تعیین واحد اول بر اساس واحد دوم

          return {
            QtyIn1: +value / obj.ConversionRatio,
          };
        }
        calculatedIsAbsoluteUnitConversionRatioFlag.current = true;
      }
    } else {
      return {
        //واحد دوم وجود ندارد و باید نال شود
        QtyIn2:null,
      };
    }
  };

  useEffect(() => {
    getPeriodInitDetailAsync();
  }, [forceUpdate, search, orderBy, filterlist]);

  return (
    <>

       {
         showImportForm &&
         <ModalForm modalHeight={80} modalProfileKey={"Users"} title={"Import"} onHide={() => setShowImportForm(false)} show={showImportForm}>
           <ImportForm reload={()=>{ setShowImportForm(false) ;setForceUpdate(!forceUpdate);}}  showForm={() => { setShowImportForm(false) }} />
         </ModalForm>
       }

       {
         showtransmissionForm &&
         <ModalForm modalHeight={80} modalProfileKey={"transmission"} title={"transfer"} onHide={() => setShowtransmissionForm(false)} show={showtransmissionForm}>
           <TransmissionForm reload={() => { setShowtransmissionForm(false); setForceUpdate(!forceUpdate); } } showForm={() => { setShowtransmissionForm(false); } } 
           onHide={() =>{setShowtransmissionForm(false) }} mode={""} />
         </ModalForm>
       }

      {showPeriodInitBulkAdd && (
        <ModalForm
          mode={mode}
          title={trans("periodInit")}
          onHide={() => setShowPeriodInitBulkAdd(false)}
          show={showPeriodInitBulkAdd}
        >
          <PeriodInitDetailBulkAdd
            saveWarehouseInPeriodInit={PeriodInitObj?.SaveWarehouseId}
            reload={() => {
              setForceUpdate(!forceUpdate);
              setShowPeriodInitBulkAdd(false);
            }}
            detailMode={detailMode}
            onHide={() => {
              setShowPeriodInitBulkAdd(false);
            }}
            PeriodInitObj={PeriodInitObj}
            editSelectedList={selectList}
          />
        </ModalForm>
      )}

      <Toolbar
         editInGrid={true}
        search={changedDataObj != null ? false : true}
        save={changedDataObj != null ? true : false}
        emptyList={response?.TotalRecords == 0}
        handleSearch={searchHandler}
        id={selectedObj}
        view={false} 
        create={
          !localStorage.getItem("DefaultInventory") || (JSON.parse(localStorage.getItem("DefaultInventory") as any)?.WarehouseDetailsCount>0 && !JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)?.Id)?false
         : 
          JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id?
          editAllGrid==EditType.SingleRow || editAllGrid==EditType.All ?false:true
          :false}
        remove={editAllGrid==EditType.SingleRow || editAllGrid==EditType.All ?false:true}
        excel={editAllGrid==EditType.SingleRow || editAllGrid==EditType.All ?false:true}
        refresh={editAllGrid==EditType.SingleRow || editAllGrid==EditType.All ?false:true}
        edit={JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id?changedDataObj == null:false}
         transfer={editAllGrid==EditType.SingleRow || editAllGrid==EditType.All ?false:true}
        Import={editAllGrid==EditType.SingleRow || editAllGrid==EditType.All ?false:true}
        cancel={editAllGrid}
        handleClickToolbar={clickToolbarCallback}
        warehouseWithDetail={editAllGrid==EditType.SingleRow || editAllGrid==EditType.All ?false:true}
      />
      <div>
        <div className="card">
          <div className="p-0">
            {loading ? (
              tbodyData.length > 0 ? (
                <DataGridEditable
                  RowKey={"Id"}
                  rowSelected={selectedObj}
                  changeingDataCallback={changeingData}
                  orderFormat={
                    changedDataObj == null
                      ? (order) => {
                          setOrderBy(order);
                        }
                      : undefined
                  }
                  orderFormatList={orderBy}
                  handlefiltering={
                    changedDataObj == null
                      ? (str) => {
                          setFilterlist(str);
                        }
                      : undefined
                  }
                  filterStr={filterlist}
                  editAllGrid={editAllGrid}
                  editablecolumns={editablecolumns}
                  setEditAllGrid={setEditAllGrid}
                  multiSelect={true}
                  selectList={selectListCallBack}
                  resetMultiSelect={resetMultiSelect}
                  mode={mode}
                  handleDelete={handleRemove}
                  showForm={showForm}
                  defaultValueOption={{ "-1": trans("CallForPrice") }}
                  columnsWithOption={["Price"]}
                  parentName={"BulletinPeriodInitDetail"}
                  startIndex={13}
                  theadData={Object.keys(response.Data[0])}
                  tbodyData={tbodyData}
                  minCellWidth={80}
                  selectedRowObjectCallback={selectedIdCallback}
                  totalRecords={response.TotalRecords}
                  pageNum={pageNum}
                  pageSize={pageSize}
                  HandleNextPage={handleNextPage}
                  HandlePrevPage={handlePrevPage}
                  handlechangePageSize={handleChangePageSize}
                  calcute={(obj, cell, value) => {
                   return handleCalculate(obj, cell, value);
                  }}
                  first={() => {
                    getPeriodInitDetailAsync(pages);
                    setPageNum(pages);
                  }}
                  end={() => {
                    getPeriodInitDetailAsync(1);
                    setPageNum(1);
                  }}
                  handleGoPage={handleGoPage}
                />
              ) : (
                <Message message={!JSON.parse(localStorage.getItem("DefaultInventory") as any)?.Id?'msg_choosewarehouse':
                  JSON.parse(localStorage.getItem("DefaultInventory") as any)?.WarehouseDetailsCount>0 && !JSON.parse(localStorage.getItem("DefaultDetailInventory") as any)?.Id?"انبار جاری فرعی مورد نظر را انتخاب کنید"
                  
                 : "NoDataForPreview"} type={messageType} />
              )
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
